/* Fuzance · carte des revendeurs aux couleurs du site.
   Les revendeurs viennent de l'application ProMap (vous les gérez dans l'app, la carte suit toute seule) :
   on charge uniquement son fichier de données (window.SCASLSetting.locationsRaw), sans son interface ni Google Maps.
   La carte est dessinée avec Leaflet et les fonds de carte OpenStreetMap (gratuits, sans clé, attribution obligatoire).
   Éléments (tous facultatifs sauf la carte), cherchés dans l'élément [data-fz-sl] :
     .fz-sl__map   la carte          .fz-sl__chips  filtres par station     .fz-sl__near  bouton « Autour de moi »
     .fz-sl__list  fiches revendeurs .fz-sl__live   message d'état (lecteurs d'écran)
   Une fiche cliquée centre la carte sur la boutique (et la fait défiler à l'écran si besoin), un repère cliqué met sa fiche en avant. */
(function(){
  var LEAFLET_CSS='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  var LEAFLET_JS='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  var TILES='https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  var DAYS=['sun','mon','tue','wed','thu','fri','sat'];
  var DAY_FR={sun:'dimanche',mon:'lundi',tue:'mardi',wed:'mercredi',thu:'jeudi',fri:'vendredi',sat:'samedi'};

  function loadScript(src){ return new Promise(function(ok,ko){ var s=document.createElement('script'); s.src=src; s.async=true; s.onload=ok; s.onerror=ko; document.head.appendChild(s); }); }
  function loadCss(href){ if(document.querySelector('link[href="'+href+'"]')) return; var l=document.createElement('link'); l.rel='stylesheet'; l.href=href; document.head.appendChild(l); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function nice(s){ s=String(s||'').trim(); return s===s.toUpperCase()?s.toLowerCase().replace(/(^|[\s\-'’])(\p{L})/gu,function(m,a,b){return a+b.toUpperCase();}):s; }
  function km(a,b,c,d){ var R=6371,r=Math.PI/180,x=(c-a)*r,y=(d-b)*r,h=Math.sin(x/2)*Math.sin(x/2)+Math.cos(a*r)*Math.cos(c*r)*Math.sin(y/2)*Math.sin(y/2); return 2*R*Math.asin(Math.sqrt(h)); }

  /* Heure actuelle à Paris : jour (sun..sat) et minutes depuis minuit */
  function nowParis(){
    var p={}; new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Paris',weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).forEach(function(x){p[x.type]=x.value;});
    return {day:p.weekday.slice(0,3).toLowerCase(),min:(+p.hour)*60+(+p.minute)};
  }
  function toMin(t){ var a=String(t||'').split(':'); return (+a[0])*60+(+a[1]||0); }
  function status(ohRaw){
    var oh; try{ oh=typeof ohRaw==='string'?JSON.parse(ohRaw):ohRaw; }catch(e){ return null; }
    if(!oh) return null;
    var n=nowParis(), di=DAYS.indexOf(n.day), today=oh[n.day];
    if(today&&today.status==1&&today.slot){
      for(var i=0;i<today.slot.length;i++){ var s=today.slot[i]; if(n.min>=toMin(s.from)&&n.min<toMin(s.to)) return {open:true,text:'Ouvert · ferme à '+s.to}; }
      for(i=0;i<today.slot.length;i++){ if(toMin(today.slot[i].from)>n.min) return {open:false,text:'Fermé · ouvre à '+today.slot[i].from}; }
    }
    for(var k=1;k<=7;k++){ var key=DAYS[(di+k)%7], d=oh[key];
      if(d&&d.status==1&&d.slot&&d.slot.length) return {open:false,text:'Fermé · ouvre '+(k===1?'demain':DAY_FR[key])+' à '+d.slot[0].from}; }
    return {open:false,text:'Fermé'};
  }

  function parse(raw){
    var list; try{ list=typeof raw==='string'?JSON.parse(raw):raw; }catch(e){ return []; }
    return (list||[]).map(function(l){
      var lat=parseFloat(l.lat), lng=parseFloat(l.lng); if(isNaN(lat)||isNaN(lng)) return null;
      var name=String(l.name||''), station=l.city||'', shop=name, m=name.split(/\s+[-–—]\s+/);
      if(m.length>1){ station=m[0]; shop=m.slice(1).join(' - '); }
      var addr=String(l.address||'').replace(/[\s,;]+$/,'');
      return {id:l.id,lat:lat,lng:lng,station:nice(station)||nice(l.city),shop:nice(shop),address:addr,phone:l.phone||'',web:l.web||'',dir:l.shareable_link||('https://www.google.com/maps/dir/?api=1&destination='+lat+','+lng),oh:l.operating_hours,prio:+l.priority||0};
    }).filter(Boolean);
  }

  function waitData(src){
    return new Promise(function(ok){
      if(window.SCASLSetting&&window.SCASLSetting.locationsRaw) return ok(window.SCASLSetting);
      if(src&&!window.SL_FIRST_LOAD_GENERAL_JS){ window.SL_FIRST_LOAD_GENERAL_JS=true; loadScript(src).catch(function(){}); }
      var t=0, iv=setInterval(function(){ t+=150; if(window.SCASLSetting&&window.SCASLSetting.locationsRaw){ clearInterval(iv); ok(window.SCASLSetting); } else if(t>12000){ clearInterval(iv); ok(null); } },150);
    });
  }

  var PIN='<svg viewBox="0 0 30 40" width="30" height="40" aria-hidden="true"><path d="M15 39C15 39 28 24.6 28 14.5A13 13 0 0 0 2 14.5C2 24.6 15 39 15 39Z" fill="currentColor" stroke="#fff" stroke-width="2.5"/><circle cx="15" cy="14.5" r="4.6" fill="#fff"/></svg>';

  function build(root){
    if(root.dataset.built) return; root.dataset.built=1;
    var listEl=root.querySelector('.fz-sl__list'), mapEl=root.querySelector('.fz-sl__map'), chipsEl=root.querySelector('.fz-sl__chips'), nearBtn=root.querySelector('.fz-sl__near'), live=root.querySelector('.fz-sl__live');
    if(!mapEl) return;
    waitData(root.dataset.src).then(function(set){
      var stores=set?parse(set.locationsRaw):[];
      if(!stores.length){
        root.classList.add('fz-sl--empty'); if(chipsEl) chipsEl.innerHTML=''; if(nearBtn) nearBtn.hidden=true;
        if(listEl) listEl.innerHTML='<li class="fz-sl__none">La liste des revendeurs arrive bientôt. Écrivez-nous à <a href="mailto:contact@fuzance.com">contact@fuzance.com</a> pour trouver le plus proche.</li>';
        return;
      }
      stores.sort(function(a,b){ return a.station.localeCompare(b.station,'fr')||b.prio-a.prio||a.shop.localeCompare(b.shop,'fr'); });
      var current='all', origin=null, map=null, markers={}, started=false;

      /* Filtres par station */
      var stations=[]; stores.forEach(function(s){ if(stations.indexOf(s.station)<0) stations.push(s.station); });
      function chip(val,label,n){ return '<button type="button" class="fz-sl__chip" data-st="'+esc(val)+'" aria-pressed="'+(val===current)+'">'+esc(label)+' <span>'+n+'</span></button>'; }
      if(chipsEl){
        chipsEl.innerHTML=chip('all','Toutes',stores.length)+stations.map(function(st){ return chip(st,st,stores.filter(function(s){return s.station===st;}).length); }).join('');
        chipsEl.addEventListener('click',function(e){ var b=e.target.closest('.fz-sl__chip'); if(!b) return; current=b.dataset.st; chipsEl.querySelectorAll('.fz-sl__chip').forEach(function(c){ c.setAttribute('aria-pressed',c===b); }); render(true); });
      }

      function visible(){ return stores.filter(function(s){ return current==='all'||s.station===current; }); }
      function card(s){
        var st=status(s.oh), d=origin?km(origin[0],origin[1],s.lat,s.lng):null;
        return '<li class="fz-sl__item" data-id="'+s.id+'">'+
          '<button type="button" class="fz-sl__focus" data-id="'+s.id+'" aria-label="Voir '+esc(s.shop)+' ('+esc(s.station)+') sur la carte"></button>'+
          '<div class="fz-sl__top"><span class="fz-sl__station">'+esc(s.station)+'</span>'+(d!=null?'<span class="fz-sl__dist">'+(d<10?d.toFixed(1).replace('.',','):Math.round(d))+' km</span>':'')+'</div>'+
          '<h3 class="fz-sl__shop">'+esc(s.shop)+'</h3>'+
          '<p class="fz-sl__addr">'+esc(s.address)+'</p>'+
          (st?'<p class="fz-sl__status'+(st.open?' is-open':'')+'"><i aria-hidden="true"></i>'+esc(st.text)+'</p>':'')+
          '<div class="fz-sl__actions">'+
            '<a class="fz-sl__btn fz-sl__btn--fill" href="'+esc(s.dir)+'" target="_blank" rel="noopener">Itinéraire<span class="fz-sr"> vers '+esc(s.shop)+' (nouvel onglet)</span></a>'+
            (s.phone?'<a class="fz-sl__btn" href="tel:'+esc(s.phone.replace(/\s+/g,''))+'">Appeler<span class="fz-sr"> '+esc(s.shop)+'</span></a>':'')+
            (s.web?'<a class="fz-sl__link" href="'+esc(s.web)+'" target="_blank" rel="noopener">Site web<span class="fz-sr"> de '+esc(s.shop)+' (nouvel onglet)</span></a>':'')+
          '</div></li>';
      }
      function render(fit){
        var v=visible();
        if(origin) v.sort(function(a,b){ return km(origin[0],origin[1],a.lat,a.lng)-km(origin[0],origin[1],b.lat,b.lng); });
        if(listEl) listEl.innerHTML=v.map(card).join('');
        if(live&&!origin) live.textContent=v.length+' revendeur'+(v.length>1?'s':'')+(current!=='all'?' à '+current:'');
        if(map){
          Object.keys(markers).forEach(function(id){ var on=v.some(function(s){return String(s.id)===id;}); var m=markers[id]; if(on&&!map.hasLayer(m)) m.addTo(map); if(!on&&map.hasLayer(m)) map.removeLayer(m); });
          if(fit) fitTo(v);
        }
      }
      function fitTo(v){
        if(!map||!v.length) return;
        var pts=v.map(function(s){return [s.lat,s.lng];}); if(origin) pts.push(origin);
        if(pts.length===1) map.setView(pts[0],14,{animate:true}); else map.fitBounds(pts,{padding:[36,36],maxZoom:14,animate:true});
      }
      function activate(id,fromMap){
        if(listEl) listEl.querySelectorAll('.fz-sl__item').forEach(function(li){ li.classList.toggle('is-active',li.dataset.id==String(id)); });
        Object.keys(markers).forEach(function(k){ var el=markers[k].getElement&&markers[k].getElement(); if(el) el.classList.toggle('is-active',k==String(id)); });
        var s=stores.filter(function(x){return String(x.id)===String(id);})[0];
        if(!fromMap){ var r=mapEl.getBoundingClientRect(); if(r.top<0||r.bottom>window.innerHeight) mapEl.scrollIntoView({block:'center',behavior:'smooth'}); }
        if(s&&map){ map.flyTo([s.lat,s.lng],Math.max(map.getZoom(),14),{duration:.6}); markers[id].openPopup(); }
        if(fromMap&&listEl){ var li=listEl.querySelector('.fz-sl__item[data-id="'+id+'"]'); if(li){ var rr=li.getBoundingClientRect(); if(rr.top<0||rr.bottom>window.innerHeight){} } }
      }
      if(listEl) listEl.addEventListener('click',function(e){ var b=e.target.closest('.fz-sl__focus'); if(b) activate(b.dataset.id,false); });

      /* Autour de moi */
      if(nearBtn){
        if(!('geolocation' in navigator)) nearBtn.hidden=true;
        nearBtn.addEventListener('click',function(){
          nearBtn.disabled=true; nearBtn.classList.add('is-busy');
          navigator.geolocation.getCurrentPosition(function(p){
            origin=[p.coords.latitude,p.coords.longitude]; nearBtn.disabled=false; nearBtn.classList.remove('is-busy');
            current='all'; if(chipsEl) chipsEl.querySelectorAll('.fz-sl__chip').forEach(function(c){ c.setAttribute('aria-pressed',c.dataset.st==='all'); });
            if(map&&window.L){ if(root._me) map.removeLayer(root._me); root._me=L.circleMarker(origin,{radius:8,color:'#fff',weight:3,fillColor:'#1F70A7',fillOpacity:1}).addTo(map).bindTooltip('Vous êtes ici'); }
            render(false);
            fitTo(visible().sort(function(a,b){ return km(origin[0],origin[1],a.lat,a.lng)-km(origin[0],origin[1],b.lat,b.lng); }).slice(0,3));
            if(live) live.textContent='Revendeurs triés du plus proche au plus loin';
          },function(){
            nearBtn.disabled=false; nearBtn.classList.remove('is-busy');
            if(live) live.textContent='Position indisponible : autorisez la localisation dans votre navigateur, ou choisissez une station.';
          },{timeout:10000,maximumAge:600000});
        });
      }

      render(false);

      /* La carte (chargée quand la section approche de l'écran, au plus tard 4 s après le chargement de la page) */
      function initMap(){
        if(started) return; started=true;
        loadCss(LEAFLET_CSS);
        (window.L?Promise.resolve():loadScript(LEAFLET_JS)).then(function(){
          map=L.map(mapEl,{scrollWheelZoom:false,zoomControl:true,attributionControl:true});
          map.attributionControl.setPrefix(false);
          L.tileLayer(TILES,{maxZoom:19,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'}).addTo(map);
          var icon=L.divIcon({className:'fz-sl__pin',html:PIN,iconSize:[30,40],iconAnchor:[15,39],popupAnchor:[0,-34]});
          stores.forEach(function(s){
            var st=status(s.oh);
            var m=L.marker([s.lat,s.lng],{icon:icon,title:s.shop+' ('+s.station+')',alt:s.shop,keyboard:true,riseOnHover:true});
            m.bindPopup('<span class="fz-sl__pst">'+esc(s.station)+'</span><strong>'+esc(s.shop)+'</strong>'+(st?'<em class="'+(st.open?'is-open':'')+'">'+esc(st.text)+'</em>':'')+'<span class="fz-sl__pact"><a href="'+esc(s.dir)+'" target="_blank" rel="noopener">Itinéraire</a>'+(s.phone?'<a href="tel:'+esc(s.phone.replace(/\s+/g,''))+'">Appeler</a>':'')+'</span>',{closeButton:false,className:'fz-sl__pop'});
            m.on('click',function(){ activate(s.id,true); });
            markers[s.id]=m;
          });
          render(true);
          mapEl.addEventListener('click',function(){ map.scrollWheelZoom.enable(); });
          mapEl.addEventListener('mouseleave',function(){ map.scrollWheelZoom.disable(); });
          root.classList.add('fz-sl--ready');
        }).catch(function(){ root.classList.add('fz-sl--nomap'); });
      }
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(e){ if(e.some(function(x){return x.isIntersecting;})){ io.disconnect(); initMap(); } },{rootMargin:'600px 0px'});
        io.observe(mapEl);
        var late=function(){ setTimeout(function(){ io.disconnect(); initMap(); },4000); };
        if(document.readyState==='complete') late(); else window.addEventListener('load',late);
      } else initMap();
    });
  }
  function init(r){ (r||document).querySelectorAll('[data-fz-sl]').forEach(build); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init();}); else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
